import styled from '@emotion/styled';
import Button from '@portalterreno/react-ui-core/Button';

const StyledButton = styled(Button)(
  {
    height: 37,
    paddingLeft: 15,
    paddingRight: 15
  },
  ({ theme }) => ({
    fontSize: theme.typography.fontSize.medium,
    border: `solid 1px ${theme.palette.secondary}`
  })
);

export default StyledButton;
